export default "__VITE_ASSET__DBX34TuFh5xxLk2gP5UDrg__"